var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._g(_vm._b({ref:"selectPicker",class:_vm._class,domProps:{"value":_vm.value}},'select',_vm.$attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }